import axiosInstance from "@/api/axiosInstance";
import { GetAdminCreateUserFormDetailsResponse } from "./types";

export const fetchAdminCreateUserFormDetails =
  async (): Promise<GetAdminCreateUserFormDetailsResponse> => {
    const response =
      await axiosInstance.get<GetAdminCreateUserFormDetailsResponse>(
        "/api/private/admin/user-form-details",
      );
    return response.data;
  };
